jQuery(document).ready(function($) {
    
	$('.header__nav-button').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('#header__nav').stop().toggleClass('active').slideToggle();
	});

	$('.menu-item-btn a').addClass('btn --orange --with-arrow');
 
});
